// import React from "react";
// export default function AppCTA() {
//   return (
//     <section className="bg-gradient-to-r from-amber-400 to-pink-400">
//       <div className="mx-auto max-w-7xl px-4 py-10 md:py-14 grid md:grid-cols-2 items-center gap-6">
//         <div>
//           <h3 className="text-2xl md:text-3xl font-black text-slate-900">Download Our Mobile App</h3>
//           <p className="mt-2 text-slate-900/80 max-w-xl">
//             Book tickets on the go. Discover events nearby. Secure payments.
//           </p>
//           <div className="mt-4 flex items-center gap-3">
//             <button className="rounded-xl bg-black text-white px-4 py-3 text-sm font-semibold">Get it on Google Play</button>
//             <button className="rounded-xl bg-black text-white px-4 py-3 text-sm font-semibold">Download on App Store</button>
//           </div>
//         </div>
//         <div className="justify-self-center">
//           <img
//             src="https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=800&auto=format&fit=crop"
//             alt="App"
//             className="h-64 w-40 object-cover rounded-[28px] shadow-2xl border-4 border-white/40"
//           />
//         </div>
//       </div>
//     </section>
//   );
// }


import React from "react";

/** Beautiful mobile-app CTA with store badges and a floating phone */
export default function AppCTA() {
  return (
    <section className="relative overflow-hidden">
      {/* Background gradient + soft shapes */}
      <div className="absolute inset-0 bg-gradient-to-br from-amber-300 via-rose-300 to-fuchsia-300" />
      <div className="absolute -top-32 -right-32 h-80 w-80 rounded-full bg-white/20 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 h-80 w-80 rounded-full bg-white/20 blur-3xl" />
      {/* Soft grain — CSS only (no external asset) */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.06] mix-blend-overlay"
        style={{
          backgroundImage:
            "repeating-radial-gradient(circle at 17% 32%, rgba(0,0,0,0.4) 0 0.6px, transparent 0.6px 3px)",
        }}
      />

      <div className="relative mx-auto max-w-7xl px-3 sm:px-4 py-10 md:py-14">
        <div className="grid items-center gap-8 md:grid-cols-2 md:gap-10">
          {/* LEFT: copy */}
          <div className="text-slate-900">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/70 px-3 py-1 text-xs font-semibold ring-1 ring-black/5">
              <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
              Comming Soon  iOS & Android 
            </div>

            <h2 className="mt-3 text-2xl font-black leading-tight md:text-3xl">
              Book Donor Passes in seconds.
              <br className="hidden sm:block" /> Discover events near you.
            </h2>

            <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-800/80 md:text-base">
              Fast checkout, secure payments, smart reminders, and personalized picks—
              all in one beautiful app.
            </p>

            {/* Social proof */}
            <div className="mt-4 flex flex-wrap items-center gap-3 text-sm">
              <StarRating rating={4.8} />
              {/* <span className="text-slate-800/80">4.8/5 • 12k+ reviews</span>
              <span className="hidden h-3 w-px bg-slate-500/20 sm:inline-block" />
              <span className="text-slate-800/80">Trusted by 500k+ users</span> */}
            </div>

            {/* Badges */}
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <a
                href="#"
                className="group inline-flex items-center gap-3 rounded-2xl bg-black px-4 py-2.5 text-white ring-1 ring-black/80 transition hover:scale-[1.02]"
                aria-label="Get it on Google Play"
              >
                <PlayLogo />
                <div className="text-left">
                  <div className="text-[10px] leading-none text-white/70">Get it on</div>
                  <div className="text-sm font-semibold leading-tight">Google Play</div>
                </div>
              </a>

              <a
                href="#"
                className="group inline-flex items-center gap-3 rounded-2xl bg-black px-4 py-2.5 text-white ring-1 ring-black/80 transition hover:scale-[1.02]"
                aria-label="Download on the App Store"
              >
                <AppleLogo />
                <div className="text-left">
                  <div className="text-[10px] leading-none text-white/70">Download on the</div>
                  <div className="text-sm font-semibold leading-tight">App Store</div>
                </div>
              </a>

              {/* <span className="ml-1 text-xs text-slate-800/70">
                Free • 33&nbsp;MB • iOS 13+ / Android 8+
              </span> */}
            </div>
          </div>

          {/* RIGHT: phone mock */}
          <div className="relative mx-auto w-[200px] sm:w-[220px]">
            {/* glow */}
            <div className="absolute -inset-6 rounded-[36px] bg-white/40 blur-3xl" />
            <div className="relative rounded-[36px] border border-white/50 bg-white/60 p-1 shadow-2xl backdrop-blur">
              <div className="relative overflow-hidden rounded-[28px] bg-black">
                {/* status bar notch */}
                <div className="absolute left-1/2 top-2 h-5 w-32 -translate-x-1/2 rounded-full bg-black/70" />
                {/* screen */}
                <img
                  src="https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=1200&auto=format&fit=crop"
                  alt="App preview"
                  className="h-[380px] sm:h-[400px] w-full object-cover opacity-[0.96]"
                />
                {/* glass reflection */}
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/20 via-transparent to-white/5" />
              </div>
            </div>

            {/* floating chips */}
            <div className="absolute -right-10 top-4 hidden md:block">
              <Chip icon="⚡">Fast checkout</Chip>
            </div>
            <div className="absolute -left-8 bottom-10 hidden md:block">
              <Chip icon="🔔">Smart reminders</Chip>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ---------------- small pieces ---------------- */
function Chip({ icon, children }) {
  return (
    <div className="select-none rounded-full bg-white/80 px-3 py-1 text-xs font-semibold text-slate-800 ring-1 ring-black/5 backdrop-blur">
      <span className="mr-1">{icon}</span>
      {children}
    </div>
  );
}

function StarRating({ rating = 5 }) {
  const full = Math.floor(rating);
  const half = rating % 1 >= 0.5;
  const empty = 5 - full - (half ? 1 : 0);

  return (
    <div className="inline-flex items-center">
      {Array.from({ length: full }).map((_, i) => (
        <Star key={`f-${i}`} className="text-amber-600" />
      ))}
      {half && <StarHalf className="text-amber-600" />}
      {Array.from({ length: empty }).map((_, i) => (
        <Star key={`e-${i}`} className="text-slate-400" />
      ))}
    </div>
  );
}

function Star({ className = "" }) {
  return (
    <svg className={`h-4 w-4 ${className}`} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2l2.9 6.26L22 9.27l-5 4.87L18.2 22 12 18.7 5.8 22l1-7.86-5-4.87 7.1-1.01L12 2z" />
    </svg>
  );
}
function StarHalf({ className = "" }) {
  return (
    <svg className={`h-4 w-4 ${className}`} viewBox="0 0 24 24">
      <defs>
        <linearGradient id="halfGrad">
          <stop offset="50%" stopColor="currentColor" />
          <stop offset="50%" stopColor="transparent" />
        </linearGradient>
      </defs>
      <path
        d="M12 2l2.9 6.26L22 9.27l-5 4.87L18.2 22 12 18.7 5.8 22l1-7.86-5-4.87 7.1-1.01L12 2z"
        fill="url(#halfGrad)"
        stroke="currentColor"
        strokeWidth="0"
      />
    </svg>
  );
}

function PlayLogo() {
  return (
    <svg className="h-6 w-6" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true">
      <path d="M325.3 234.3L104.6 13.6C95.8 4.8 80 11 80 24v464c0 13 15.8 19.2 24.6 10.4l220.7-220.7c12.5-12.5 12.5-32.8 0-45.4zM362.7 197l-27.3-15.2-35.6 35.6 35.6 35.6 27.3-15.2 75.4-42c14.3-8 14.3-28.8 0-36.8l-75.4-42z"/>
    </svg>
  );
}
function AppleLogo() {
  return (
    <svg className="h-6 w-6" viewBox="0 0 256 315" fill="currentColor" aria-hidden="true">
      <path d="M213.1 167.7c-.5-53 43.2-78.1 45.2-79.4-24.6-36-62.8-41-76.3-41.6-32.5-3.3-63.4 19.2-79.9 19.2-16.7 0-42-18.7-69.2-18.2-35.6.5-68.5 20.7-86.8 52.5-37.1 64.3-9.4 158.9 26.7 210.9 17.8 25.7 39 54.6 66.7 53.6 26.8-1 36.9-17.3 69.1-17.3 31.9 0 41.6 17.3 69.4 16.8 28.7-.5 47-26.3 64.9-52.1 20.3-29.7 28.6-58.4 29.1-59.9-.6-.3-55.8-21.4-56.1-84.5zM172.6 54.8C186.2 38.6 195.3 16 192.8 0 176.1.7 153.4 10.6 140 26.8 127.7 41.8 118.2 64.9 121.3 86.1c20.2 1.6 40.9-10.3 51.3-31.3z"/>
    </svg>
  );
}
